import { Box, Heading, List} from "@chakra-ui/react";
import CompanyProcessListItem from "./CompanyProcessListItem";
import type { CompanyProcessListsProps } from "./types";

const CompanyProcessLists = ({data, selectedItem,onSelectItem}: CompanyProcessListsProps) => {
    return (
        <Box 
            as="aside" 
            pos="sticky" 
            w="28rem" 
            h="calc(100vh - 5rem)" 
            bg="white" 
            top={16} 
            overflow="auto" 
            borderRadius={8}
        >
            <Box position="sticky" top={0} w="100%" h="3rem" py={4} px={2} bg="white">
                <Heading as="h4" fontSize="lg">Sociedades</Heading>
            </Box>
            <Box as="nav" pl={2}>
                <List>
                    {
                        data?.map((item) =>(
                            <CompanyProcessListItem 
                            key={item.id} 
                            item={item} 
                            isSelected={item === selectedItem} 
                            onSelectItem={onSelectItem}
                            />
                        ))
                    }
                </List>
            </Box>

        </Box>
    )
}

export default CompanyProcessLists
